import { AfterViewInit, Component, effect, OnInit } from '@angular/core';
import { MenubarModule } from 'primeng/menubar';
import { ButtonModule } from 'primeng/button';
import { AppService } from 'app/app.service';
import { TextSizeService } from '@shared/services/text-size.service';
import { CommonModule } from '@angular/common';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { MenuModule } from 'primeng/menu';
import { MenuItem } from 'primeng/api';
import { FlightdetailService } from 'app/features/flights/flight-detail/service/flightdetail.service';
import { EMPTY, map, Observable, of, Subscription, switchMap, tap } from 'rxjs';
import { RequestState, RequestStatus } from '@shared/models/request-state';
import { CrewDetail } from 'app/features/flights/flight-detail/model/crew-detail';
import { SignalsService } from '@shared/services/signals/signals.service';
import { em } from '@fullcalendar/core/internal-common';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [
    CommonModule,
    MenubarModule,
    ButtonModule,
    MenuModule
  ],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss'
})
export class NavBarComponent implements OnInit {

  constructor(
    public appService: AppService,
    private textSizeService: TextSizeService,
    private oidcService: OidcSecurityService,
    private flightDetailsService: FlightdetailService,
    private signalsService: SignalsService
  ) {
  }

  //Browser Theme Switcher only
  themeSwitcher: boolean = false;
  navbarSize$ = this.textSizeService.navbarSize$;
  items: MenuItem[] = [];
  activeEmpNumDetails$?: Observable<CrewDetail>;

  ngOnInit(): void {
    this.activeEmpNumDetails$ = this.signalsService.authEmployeeNumber$
    .pipe(
      switchMap((empNum) => {
        const cacheId = `member.loggedin`;
        if (!empNum) {
          const emptyUser: CrewDetail = {
            username: '',
            firstName: '',
            lastName: 'unknown',
            middleName: '',
            nickName: '',
            seat: ''
          }
          this.loadMenuItems(emptyUser);
          return of(emptyUser);
        }
        return this.flightDetailsService.getCrewDetailsFor([empNum], cacheId).pipe(
          map((response) => {
            if (!response || !response.response) {
              const emptyUser: CrewDetail = {
                username: '',
                firstName: '',
                lastName: 'unknown',
                middleName: '',
                nickName: '',
                seat: ''
              }
              this.loadMenuItems(emptyUser);
              return emptyUser;
            }
            this.loadMenuItems(response.response[0]);
            return response.response[0]
            
          })
        );
      })
    )    
  }

  loadMenuItems(empDetails?: CrewDetail): void {
    const username = empDetails?.username || '';
    const firstName = empDetails?.firstName || '';
    const lastName = empDetails?.lastName || 'unknown';
    const nickName = empDetails?.nickName || '';
    const fullName = `${nickName ? nickName : firstName} ${lastName}`;
    this.items = [
      {
        label: 'Options',
        items: [
          {
            label: 'Logout',
            icon: 'pi pi-sign-out',
            //shortcut: '⌘+N',
            command: () => this.logout()
          },
          {
            label: 'Theme',
            icon: 'pi pi-moon',
            //shortcut: '⌘+N',
            command: () => this.toggleTheme()
          }
        ]
      }
    ]
  }

  toggleTheme() {
    this.appService.toggleTheme();
  }

  logout(): void {
    this.oidcService.logoff().subscribe((result) => console.log(result));
  }

}
